import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Companion extends Bloc {

	constructor (src, ctx) {

		super("companion", src, ctx);
		this.f = (src, ins) => [src.master.run.companion];
		this.types = [];
	}
}